/* Importing the necessary modules. */
import React, { Fragment } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import detectBrowserLanguage from 'detect-browser-language'
import sanitizeHtml from 'sanitize-html'
import { error_block } from './data/error_block.json';
import { lobRoot, defaultMetaDescription } from "../../utils/LobLogicModule";
import './ErrorBlock.scss';

/* This is a React component. */
const ErrorBlock = ({errorId}) => {
    /* A hook that allows us to use the i18next library. */
    const { t, i18n } = useTranslation('error_block');
    if (detectBrowserLanguage().startsWith('es')) {
      i18n.changeLanguage('es');
    }

	/* Returning the HTML code that is to be rendered. */
    
    return (
        <Fragment>
        <Helmet>
            <html lang={t(error_block.lang) + "-US"} />
            <meta name="description" content={defaultMetaDescription}/>
        </Helmet>
        <div className='errorblock container_wrapper errorblock__bg'>
            <div className='errorblock__wrapper'>
                <div className='errorblock__column'>
                    <div className='errorblock__linktainer'>
                        <img src={errorId === 404 ? `${process.env.PUBLIC_URL}/assets/icons/icon_stop.svg` : `${process.env.PUBLIC_URL}/assets/icons/icon_alert.svg`} alt={errorId === 404 ? 'stop' : 'alert'}/>
                    </div>
                    {errorId === 404 ? <h1 className='errorblock__heading' dangerouslySetInnerHTML={{ __html:  t(error_block.fof.error.heading) }}></h1> : <h1 className='errorblock__heading' dangerouslySetInnerHTML={{ __html:  t(error_block.oneOtwo.error.heading) }}></h1>}
                    {errorId === 404 ? <p className='errorblock__copy' dangerouslySetInnerHTML={{ __html: t(error_block.fof.error.copy) }}></p> : ''}
                    {errorId === 404 ? 
                        <div className='errorblock__linktainer'>
                            <Link to={{ 
                                pathname: sanitizeHtml( t(error_block.fof.error.ctaURL)), 
                                /* pass state to the next page. */
                                state: lobRoot === '/' ? '' : 'fromErrorDB' }} 
                                className="errorblock__link t-track-cta" 
                                dangerouslySetInnerHTML={{ __html: t(error_block.fof.error.cta) }} 
                                data-bactmln="ErrorBlock-_-CTA-_-DB"></Link>
                            <Link to={{ 
                                pathname: sanitizeHtml( t(error_block.fof.error.ctaURLSB)), 
                                /* pass state to the next page. */
                                state: lobRoot === '/sb/smallbusiness' ? '' : 'fromErrorSB' }} 
                                className="errorblock__link t-track-cta" 
                                dangerouslySetInnerHTML={{ __html: t(error_block.fof.error.ctaSB) }} 
                                data-bactmln="ErrorBlock-_-CTA-_-SB"></Link>
                        </div> 
                    : ''
                    }
                    </div>
            </div>
        </div>
        </Fragment>
    )
}

/* Exporting the ErrorBlock component. */
export default ErrorBlock;